import {Injectable, NgZone, inject} from '@angular/core';
import posthog from 'posthog-js';
import {environment} from 'src/environments/environment';
import {isIntegrationFlowPage} from 'src/app/services/integrations/integration-approval-browser';

@Injectable({providedIn: 'root'})
export class PosthogService {
	private ngZone = inject(NgZone);
	/** No analytics on the pages of an integration's connection: their URL carries a token or a provider code. */
	private readonly enabled = !isIntegrationFlowPage(window.location.pathname);

	constructor() {
		if (!this.enabled) {
			return;
		}
		this.ngZone.runOutsideAngular(() => {
			posthog.init(environment.posthogKey, {
				api_host: environment.posthogHost,
				ui_host: 'https://eu.posthog.com',
				defaults: '2026-01-30',
				capture_exceptions: true,
			});
		});
	}

	capture(event: string, properties?: Record<string, unknown>): void {
		if (this.enabled) {
			posthog.capture(event, properties);
		}
	}

	captureException(error: Error, properties: Record<string, string | number>): void {
		if (this.enabled) {
			this.ngZone.runOutsideAngular(() => posthog.captureException(error, properties));
		}
	}

	identify(distinctId: string, properties?: Record<string, unknown>): void {
		if (this.enabled) {
			posthog.identify(distinctId, properties);
		}
	}

	reset(): void {
		if (this.enabled) {
			posthog.reset();
		}
	}
}
